'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/reset-password-form.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');
var _reactRouterDom = require('react-router-dom');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes2 = require('@marmalade/prop-types');
var _fieldInfo = require('@marmalade/form/lib/selectors/field-info');
var _form = require('@marmalade/form/lib/components/form');
var _form2 = _interopRequireDefault(_form);
var _email = require('@marmalade/form/lib/questions/email');
var _email2 = _interopRequireDefault(_email);
var _button = require('@marmalade/button');
var _button2 = _interopRequireDefault(_button);
var _loading = require('@marmalade/loading');
var _loading2 = _interopRequireDefault(_loading);
var _message = require('@marmalade/message');
var _message2 = _interopRequireDefault(_message);
var _actions = require('../actions');
var _selectors = require('../selectors');
var _constants = require('../constants');
var _validation = require('../validation');
var _girlAtDeskConfused = require('../../images/girl-at-desk-confused.svg');
var _girlAtDeskConfused2 = _interopRequireDefault(_girlAtDeskConfused);
var _accountPanel = require('./account-panel');
var _accountPanel2 = _interopRequireDefault(_accountPanel);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // STYLEME

var formId = _constants.forms.resetPassword;
var ResetPasswordForm = function (_Component) {
  _inherits(ResetPasswordForm, _Component);
  function ResetPasswordForm() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, ResetPasswordForm);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResetPasswordForm.__proto__ || Object.getPrototypeOf(ResetPasswordForm)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (formState) {
      if (formState.validAndPristine) {
        _this.props.resetPassword(_this.props.product, _this.props.email);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(ResetPasswordForm, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      return _react2.default.createElement(_accountPanel2.default, {
        img: _girlAtDeskConfused2.default,
        alt: 'Girl at desk confused',
        icon: props.passwordHasBeenReset ? 'thumbs-up' : 'envelope',
        title: props.passwordHasBeenReset ? 'Done!' : 'Forgot your password?',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 46
        },
        __self: this
      }, props.passwordHasBeenReset ? _react2.default.createElement(_glamorous2.default.Div, {
        css: {
          textAlign: 'center'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53
        },
        __self: this
      }, _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54
        },
        __self: this
      }, 'If ', props.email, ' exists in our system, you\'ll receive instructions from updates@wearemarmalade-news.co.uk.'), _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 58
        },
        __self: this
      }, 'If you don\'t receive an email, check your spam folder or', ' ', _react2.default.createElement(_glamorous2.default.A, {
        onClick: props.resetPasswordReset,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60
        },
        __self: this
      }, 'try again'), '.')) : _react2.default.createElement(_react.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 64
        },
        __self: this
      }, _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65
        },
        __self: this
      }, 'Don\'t panic! We\'ll email you instructions to set your password.'), _react2.default.createElement(_form2.default, {
        id: formId,
        handleSubmit: this.handleSubmit,
        validator: _validation.resetPasswordValidator,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 66
        },
        __self: this
      }, props.passwordResetError ? _react2.default.createElement(_message2.default, {
        type: 'warning',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 68
        },
        __self: this
      }, 'Sorry, there has been a problem setting your password. Please try again.') : null, _react2.default.createElement(_email2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72
        },
        __self: this
      }), _react2.default.createElement(_glamorous2.default.Div, {
        css: {
          textAlign: 'center'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 73
        },
        __self: this
      }, props.isRequestingPasswordReset ? _react2.default.createElement(_loading2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75
        },
        __self: this
      }) : _react2.default.createElement(_button2.default, {
        type: 'submit',
        prominence: 'primary',
        text: 'Send me instructions',
        block: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 77
        },
        __self: this
      }), _react2.default.createElement(_reactRouterDom.Link, {
        to: '/login',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 79
        },
        __self: this
      }, 'Return to login')))));
    }
  }]);
  return ResetPasswordForm;
}(_react.Component);
ResetPasswordForm.propTypes = {
  product: _propTypes2.product.isRequired,
  history: _propTypes2.history.isRequired,
  /* eslint-enable */
  // dtp
  resetPasswordReset: _propTypes.func.isRequired,
  resetPassword: _propTypes.func.isRequired,
  // stp
  isRequestingPasswordReset: _propTypes.bool.isRequired,
  passwordResetError: _propTypes.bool.isRequired,
  passwordHasBeenReset: _propTypes.bool.isRequired,
  email: _propTypes.string.isRequired
};
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    isRequestingPasswordReset: (0, _selectors.isRequestingPasswordReset)(state),
    passwordResetError: (0, _selectors.passwordResetError)(state),
    passwordHasBeenReset: (0, _selectors.passwordHasBeenReset)(state),
    email: (0, _fieldInfo.getValue)(state, formId, 'email') || ''
  };
}, {
  resetPasswordReset: _actions.resetPasswordReset,
  resetPassword: _actions.resetPassword
})(ResetPasswordForm));